import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
  DialogTrigger,
} from "@/components/ui/dialog"
import { Button } from "@/components/ui/button"
import { FileBarChart } from "lucide-react"

export function AppointmentStatsDialog({ stats }) {
  return (
    <Dialog>
      <DialogTrigger asChild>
        <Button variant="outline" size="sm">
          <FileBarChart className="h-4 w-4" />
          See Stats
        </Button>
      </DialogTrigger>
      <DialogContent className="sm:max-w-md">
        <DialogHeader>
          <DialogTitle>Appointment Statistics</DialogTitle>
        </DialogHeader>
        <div className="grid grid-cols-2 gap-4 py-4">
          <div className="space-y-4">
            <div className="flex items-center justify-between p-3 bg-amber-50 rounded-lg">
              <span className="text-amber-700">Pending</span>
              <span className="font-semibold text-amber-600">
                {stats.PENDING}
              </span>
            </div>
            <div className="flex items-center justify-between p-3 bg-green-50 rounded-lg">
              <span className="text-green-700">Approved</span>
              <span className="font-semibold text-green-600">
                {stats.APPROVED}
              </span>
            </div>
          </div>
          <div className="space-y-4">
            <div className="flex items-center justify-between p-3 bg-blue-50 rounded-lg">
              <span className="text-blue-700">Completed</span>
              <span className="font-semibold text-blue-600">
                {stats.COMPLETED}
              </span>
            </div>
            <div className="flex items-center justify-between p-3 bg-red-50 rounded-lg">
              <span className="text-red-700">Rejected</span>
              <span className="font-semibold text-red-600">
                {stats.REJECTED}
              </span>
            </div>
          </div>
        </div>
      </DialogContent>
    </Dialog>
  )
}
